<template>
  <div>
    <b-modal :title="modalTitle" v-model="showModal" size="lg" centered :hide-footer="hideFooter">
      <iframe :src="consentUrl" style="width: 100%; height: 80vh; border: none"></iframe>
      <template #modal-footer>
        <b-button class="mx-auto bttn bttn--lg bttn--blue" @click="showModal = false">
          {{ $t("common.close", "Close") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "AdditionalConsentUrlModal",

  data() {
    return {
      showModal: false,
      consentUrl: "",
      hideFooter: true,
      title: "",
    };
  },

  computed: {
    modalTitle() {
      return (
        this.title ||
        this.$t(
          "gateways.crowded_additional_consent_url_modal_title",
          "Additional Consent Required"
        )
      );
    },
  },

  methods: {
    open(url, title = "") {
      this.consentUrl = url;
      this.title = title;
      this.showModal = true;
      this.hideFooter = true;
    },
    handleMessage(event) {
      // Optionally, check event.origin here for security
      if (event.data && event.data.status === "Success") {
        this.hideFooter = false;
      }
    },
  },

  mounted() {
    window.addEventListener("message", this.handleMessage);
  },

  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
};
</script>
